module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pagination is-centered is-rounded",
    attrs: {
      "role": "navigation",
      "aria-label": "pagination"
    }
  }, [_c('ul', {
    staticClass: "pagination-links"
  }, [_c('li', [_c('a', {
    staticClass: "pagination-previous",
    attrs: {
      "disabled": _vm.pagination.current_page <= 1
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changePage(1)
      }
    }
  }, [_vm._v("First page")]), _vm._v(" "), _c('a', {
    staticClass: "pagination-previous",
    attrs: {
      "disabled": _vm.pagination.current_page <= 1
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changePage(_vm.pagination.current_page - 1)
      }
    }
  }, [_vm._v("Previous")])]), _vm._v(" "), _vm._l((_vm.pages), function(page) {
    return _c('li', [_c('a', {
      staticClass: "pagination-link number",
      class: _vm.isCurrentPage(page) ? 'is-current active' : '',
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.changePage(page)
        }
      }
    }, [_vm._v(_vm._s(page))])])
  }), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "pagination-next",
    attrs: {
      "disabled": _vm.pagination.current_page >= _vm.pagination.last_page
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changePage(_vm.pagination.current_page + 1)
      }
    }
  }, [_vm._v("Next page")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "pagination-next",
    attrs: {
      "disabled": _vm.pagination.current_page >= _vm.pagination.last_page
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changePage(_vm.pagination.last_page)
      }
    }
  }, [_vm._v("Last page")])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-67a7babd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pagination.vue
// module id = 1692
// module chunks = 1